export const PAYMENT_TYPES = {
  CASH: "CASH",
  CARD_PRESENT: "CARD_PRESENT",
  CARD_NOT_PRESENT: "CARD_NOT_PRESENT",
  GIFT_CARD: "GIFT_CARD",
  E_GIFT_CARD: "E_GIFT_CARD",
  REWARD: "REWARD",
  BALANCE: "BALANCE",
  CUSTOM_TYPE: "CUSTOM_TYPE",
  BILLING: "BILLING",
  CHECK: "CHECK"
}
